export default {
  error: {
    time: '動画の録画時間が短すぎます、もう一度録画してください。',
    save: '保存失敗',
    delete: 'このアセットは削除されました、もう一度選択してください。',
  },
  success: {
    msg: '録画保存完了',
    export: 'エクスポートタスクが送信されました',
    delet: '削除完了',
    save: '保存完了',
    copy: 'コピー完了',
  },
  empty: {
    title: 'このプロジェクトにはまだバージョンがありません',
    desc: '今すぐバージョンを作成して録画を開始しましょう',
    add: 'バージョンを作成',
  },
  navbar: {
    backList: '録画プロジェクトリストに戻る',
    record: 'スクリーンレコーダー',
    save: '保存',
    export: 'エクスポート',
    exportList: 'エクスポートリスト',
  },
  left: {
    title: '製品＆プロジェクト',
    projectInfo: {
      drop: 'プロジェクト',
      add: 'バージョンを作成',
    },
    version: {
      title: 'バージョン',
      copy: 'コピー',
      delete: '削除',
      copyDrop: {
        title: 'バージョンのコピー',
        text: 'バージョン名',
      },
      delDrop: {
        title: 'ヒント',
        text: '{versionname}バージョンを削除しますか',
      },
    },
  },
  work: {
    top: {
      again: '再',
      start: '開始',
      record: '録画',
      finish: '録画完了',
      play: '録画再生',
      palying: '録画再生中',
      palyed: '再生が終了しました',
      againLoad: 'リロード',
    },
  },
  right: {
    recordParameter: '録画パラメータ',
    videoSet: 'ビデオ設定',
    videoSetting: {
      cursor: 'カーソルの録画',
      time: '表示タイミング',
      clickDisplay: 'クリックで表示',
      allDisplay: '常に表示',
      cursorSize: 'カーソルサイズ',
      rotation: '回転角度',
      image: '画像',
    },
  },
  exportList: {
    title: 'バージョンエクスポート履歴',
  },
  imageUpload: {
    uploadRuleTips: {
      format: '画像ファイルフォーマット',
      fileSize: '画像ファイルサイズ',
    },
  },
  PromptMessage: {
    assetNotFound: {
      title: 'リソースが見つかりません',
      label: 'プロジェクトに追加されたアセットは削除されました。',
      continueLabel:
        'プロジェクトに追加されたアセットは削除されました。エクスポートによりプロジェクトの内容が欠落する可能性があります。続行しますか？',
    },
    pleaseEnter: '入力してください',
  },
  rule: {
    createSuccess: '作成成功',
    nameLength: '名前の長さは20文字の間にする必要があります',
    size: 'サイズを選択してください',
    resolution: '解像度を選択してください',
  },
}
